import { motion } from 'framer-motion';
import { FC, ReactNode, useEffect, useState } from 'react';

type ExpandingFieldsProps = {
  children: ReactNode;
  isOpen: boolean;
};

/**
 * Clipped only while the height moves: the expiry section holds an interval dropdown that opens
 * past its own bounds, so a permanent `overflow-hidden` would cut the options off.
 */
export const ExpandingFields: FC<ExpandingFieldsProps> = ({ children, isOpen }) => {
  const [allowOverflow, setAllowOverflow] = useState(isOpen);

  useEffect(() => {
    if (!isOpen) {
      setAllowOverflow(false);
    }
  }, [isOpen]);

  return (
    <motion.div
      animate={isOpen ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
      className={allowOverflow ? 'overflow-visible' : 'overflow-hidden'}
      // No entry animation on mount: an edited link opens with its stored settings already applied,
      // and animating those into place would read as the viewer having just switched them on.
      initial={false}
      onAnimationComplete={() => setAllowOverflow(isOpen)}
      transition={{ duration: 0.24, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};
